import axios from 'axios';
import {req, reqJson} from './axiosFun';

/**
 * 表白墙信息管理
 **/
// 获取列表
export const postsList = (params) => {
  var url = "/api/posts/admin/page?page=" + params.pageNum + "&limit=" + params.pageSize;
  if (params.schoolId != null) {
    url += "&schoolId=" + params.schoolId;
  }
  if (params.topic != null && params.topic != '') {
    url += "&topic=" + params.topic;
  }
  if (params.title != null && params.title != '') {
    url += "&title=" + params.title;
  }
  if (params.isTop != null && params.isTop != '') {
    url += "&isTop=" + params.isTop;
  }
  return reqJson("get", url)
};
//删除帖子
export const deleteById = (params) => {
  return reqJson("post", "/api/posts/admin/delete/" + params.id)
};
//置顶帖子
export const topById = (params) => {
  return reqJson("post", "/api/posts/admin/top/" + params.id)
};
//取消置顶帖子
export const cancelTopById = (params) => {
  return reqJson("post", "/api/posts/admin/cancelTop/" + params.id)
};



// WEBPACK FOOTER //
// ./src/api/postsMG.js